export default {
  text: {
    instructions: 'instructions',
    prepare: 'Prepare the Box',
    design1: "Let's Design",
    design2: 'Draw parts on the box',
    designWarning1:
      'Note that the graphic position may vary by countries and sizes',
    designWarning2:
      'Sketch the entire drawing first so that it fits in the box',
    designWarning3: 'number = spaces between dots',
    cutAndAssemble1: "Let's Cut & Assemble",
    cutAndAssemble2: 'Be careful not to hurt yourself when using the cutter',
    cutAndAssemble3: 'Cut out parts',
    cutAndAssemble4: 'Assemble',
    complete: 'Done!',
    backButton: 'Go back to main menu',
  },
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/00_TV serif new_box/serifnew_box${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/tv console.png'),
  designImageList: [
    {
      number: 1,
      // text: "❶",
      side: 'LEFT',
      image: require('../../../parts/tv_console/1.png'),
    },
    {
      number: 2,
      // text: "❷",
      side: 'RIGHT',
      image: require('../../../parts/tv_console/2.png'),
    },
    {
      number: 3,
      text: '-a',
      side: 'TOP',
      image: require('../../../parts/tv_console/3a.png'),
    },
    {
      number: 3,
      text: '-b',
      side: 'TOP',
      image: require('../../../parts/tv_console/3b.png'),
    },
    {
      number: 4,
      // text: "❹",
      side: 'BACK',
      image: require('../../../parts/tv_console/4.png'),
    },
    {
      number: 5,
      // text: "❺",
      side: 'MIDDLE',
      image: require('../../../parts/tv_console/5.png'),
    },
    {
      number: 6,
      text: '-a',
      side: 'BOTTOM',
      image: require('../../../parts/tv_console/6a.png'),
    },
    {
      number: 6,
      text: '-b',
      side: 'BOTTOM',
      image: require('../../../parts/tv_console/6b.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/tv_console/cutter.png'),

  assembleSequenceImages: Array(50)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/01_console_sequence/console${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),

  completeImage: require('../../../complete/tv_console.png'),
  completeImagePc: require('../../../complete/tv_console.png'),
};
